import { render, staticRenderFns } from "./EcertSearch.vue?vue&type=template&id=6d666de0&scoped=true&"
import script from "./EcertSearch.vue?vue&type=script&lang=js&"
export * from "./EcertSearch.vue?vue&type=script&lang=js&"
import style0 from "./EcertSearch.vue?vue&type=style&index=0&id=6d666de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d666de0",
  null
  
)

export default component.exports